import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class Wk8DemoService {
  readonly #activatedRoute = inject(ActivatedRoute);

  public hasTutorialsDisabled(): boolean {
    return (
      this.#activatedRoute.snapshot.queryParamMap
        .get('variant')
        ?.split(',')
        .map((t) => t.trim())
        .includes('NO_TUTS') ?? false
    );
  }
}
